import type { RuntimeConfig } from '@nuxt/schema';
import { createMercureClient } from '~/composables/mercure';
import { useUsersStore } from '~/stores/users';
import type { MercureClient } from '~/composables/mercure';

declare module '#app' {
  interface NuxtApp {
    $mercure: MercureClient;
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $mercure: MercureClient;
  }
}

export default defineNuxtPlugin(() => {
  const config: RuntimeConfig = useRuntimeConfig();

  const hubUrl = config.public.mercureHubUrl ||
    (config.public.API_ROOT_URL
      ? new URL('/.well-known/mercure', config.public.API_ROOT_URL).toString()
      : undefined);

  if (!hubUrl) {
    throw new Error('[Mercure Plugin] Missing hub URL. Configure NUXT_PUBLIC_MERCURE_HUB_URL or API_ROOT_URL.');
  }

  const debug = config.public.mercure?.debug || false;

  const mercureClient: MercureClient = createMercureClient({
    hubUrl,
    debug,
    refreshToken: async (): Promise<string | null> => {
      const usersStore = useUsersStore();
      await usersStore.fetchMe();

      return usersStore.authUserMeta?.mercure?.token ?? null;
    },
  });

  if (debug) {
    console.log('[Mercure Plugin] Initialized with hub:', hubUrl);
  }

  return {
    provide: {
      mercure: mercureClient,
    },
  };
});
